import { createSlice } from '@reduxjs/toolkit';
import { apiString as API_URL } from '../utils/constants';
import { AppThunk } from './store';
import axios from 'axios';

const populations = createSlice({
    name: 'populations',
    initialState: {
        isFetching: false,
        populations: [],
        analyticPopulations: [],
    },
    reducers: {
        _setIsFetching(state, action) {
            state.isFetching = action.payload;
        },
        _setPopulations(state, action) {
            state.populations = action.payload;
        },
        _setAnalyticPopulations(state, action) {
            state.analyticPopulations = action.payload;
        },
    },
});

const { _setIsFetching, _setPopulations, _setAnalyticPopulations } = populations.actions;

export const isFetching =
    (fetching: boolean): AppThunk =>
    async (dispatch) => {
        dispatch(_setIsFetching(fetching));
    };

export const fetchPopulations = (): AppThunk => async (dispatch) => {
    const response = await axios.get(`${API_URL}/population/getactivepopulation`);
    if (response.status === 200) {
        var popInfo = response.data;
        var popList = [];
        for (var r in popInfo) {
            if (popInfo.hasOwnProperty(r)) {
                var pop = { value: parseInt(r), name: popInfo[r] };
                popList.push(pop);
            }
        }
        dispatch(_setPopulations(popList));
    }
};

export const fetchAnalyticPopulations = (): AppThunk => async (dispatch) => {
    const response = await axios.get(`${API_URL}/population/getanalyticpopulation`);
    if (response.status === 200) {
        var popInfo = response.data;
        var popList = [];
        for (var r in popInfo) {
            if (popInfo.hasOwnProperty(r)) {
                var pop = { value: parseInt(r), name: popInfo[r] };
                popList.push(pop);
            }
        }
        dispatch(_setAnalyticPopulations(popList));
    }
};

export default populations.reducer;
